import AutoSubmit from "../components/AutoSubmit";
import BulkAction from "../components/BulkAction";
import AssetUploader from "../components/uploads/AssetUploader";

export default class ResidentBusinessGuidesBusinessListings {
  constructor(params) {
    this.params = params;
    this.toasting = false;
  }

  index() {
    new AutoSubmit();

    new BulkAction({
      target: "#business-listings-bulk-store",
      action: "#rbg-bulk-action",
      secondary_nav: "#rbg-action-bar",
      checked_scope: "td",
    });

    new N2Styles.searchBar({
      safeContainer: ".js-table-search",
      showSelector: ".show-table-search",
      visible: this.params.search,
    });

    this.bindDisabledToasts();
  }

  unload() {
    if (this.assetUploader) {
      this.assetUploader.unload();
    }
  }

  new() {
    this.assetUploader = new AssetUploader(this, { showFileName: false, redirectOnSubmit: true });
    this.assetUploader.init();

    $(".js-rbg-instructions-modal").modal();
    $(".modal-backdrop").addClass("in");

    N2.handle("click", "#rbg-instructions-link", () => {
      new N2Styles.modalOpener($(".js-rbg-instructions-modal"), {});
    });
  }

  assetUploadUrl() {
    return `/resident_business_guides/${this.params.residentBusinessGuideId}/business_listing_uploads?import_type=append`;
  }

  assetUploadImageLabel() {
    return "File";
  }

  // For disabled controls on the business listings, show a toast explaining why
  // they can't be used and make sure it doesn't spam the screen if they try to
  // click multiple times / multiple elements.
  bindDisabledToasts() {
    N2.handle("click", ".disabled, [disabled]", () => {
      if (this.toasting) { return; }
      this.toasting = true;
      new N2Styles.toast("That action is only available when this publication is in Waiting status.");
      setTimeout(() => {
        this.toasting = false;
      }, 5000);
    });
  }
}
